import { render, staticRenderFns } from "./CodeExampleSource.vue?vue&type=template&id=4db65d17&scoped=true&lang=pug&"
import script from "./CodeExampleSource.vue?vue&type=script&lang=ts&"
export * from "./CodeExampleSource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db65d17",
  null
  
)

export default component.exports